<template>
  <div class="news content">
    <div class="banner-sub">
      <img :src="topBg.bannerImg" alt="">
    </div>
    <div class="wrap">
      <div class="title">
        <h2>新闻资讯</h2>
        <span></span>
      </div>
      <div class="news-part1">
        <div class="box-list">
          <div v-for="(item, idx) in newsList" :key="idx" @click="toNewsInfo(item.id)" @mouseover="newsItemHover(item)"
            :class="{'active' : item.id === hoverNewsItem.id}" class="item">
            <div class="img-box"><img class="img-cover" :src="item.img" width="496" height="310" /></div>
            <div class="mod9">
              <h2 class="word10 ellipsis">{{ item.title }}</h2>
              <span class="info5">{{ item.publicTime }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="page" style="margin-bottom: 76px;">
        <pagination :pagination="pagination" :callback="getTableData" :options="paginationOptions"></pagination>
      </div>
    </div>
    <!-- <div class="product-demo mt30">
      <img class="imgbg" src="~@/assets/img/news_banner.jpg" alt="">
      <div class="news-demo-txt">
        <div class="wrap">
          <div class="title">
            <h2>点击排行</h2>
            <span></span>
          </div>
          <div class="product-demo-list">
            <div class="swiper-container">
              <div class="swiper-wrapper" v-if="topNewsList && topNewsList.length > 0">
                <template >
                  <div
                    @click="toNewsInfo(item.id)"
                    v-for="(item,index) in topNewsList"
                    :key="index"
                    class="swiper-slide product-demo-list-item">
                    <div class="swiper-img">
                      <div class="img-com">
                        <img class="imgbg" :src="item.img" alt="">
                      </div>
                    </div>
                    <div class="swiper-txt">
                      <span>{{ item.title }}</span>
                    </div>
                  </div>
                </template>
              </div>
              <div class="swiper-pagination"></div>
              <div class="swiper-button-next"></div>
              <div class="swiper-button-prev"></div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import pagination from 'vue-bootstrap-pagination'
import { ApiWebArticleTop, ApiWebArticleNews, ApiWebArticleHotLabel, ApiWebArticleTopRead, ApiWebArticleBg } from '../api/news'
export default {
  name: 'news',
  data () {
    return {
      pagination: {
        per_page: 9, // 每页数
        current_page: 1, // 当前页
        last_page: 0 // 总页数
      },
      paginationOptions: {
        offset: 4,
        previousText: '<',
        nextText: '>',
        alwaysShowPrevNext: true
      },
      // 新闻分页列表
      newsList: [],
      // top6
      topNewsList: [],
      // 置顶新闻
      topNews: {},
      // 标签列表
      labelList: [],
      topBg: {},
      hoverNewsItem: {}
    }
  },
  components: {
    pagination
  },
  mounted () {
    this.initTop()
    this.topReadNews()
    this.initNews()
    this.initLabel()
    this.topbackground()
  },
  methods: {
    /**
     * 分页回调函数
     */
    getTableData () {
      this.initNews()
    },
    /**
     * 置顶新闻
     */
    initTop () {
      ApiWebArticleTop().then(({data}) => {
        if (data && data.status === 0) {
          this.topNews = data.data
        }
      })
    },
    /**
     * 初始化新闻列表
     */
    initNews () {
      let params = {
        page: {
          curr: this.pagination.current_page,
          size: this.pagination.per_page
        },
        form: {
          label: ''
        }
      }
      ApiWebArticleNews(params).then(({data}) => {
        if (data && data.status === 0) {
          let table = data.data
          this.newsList = table.list
          this.hoverNewsItem = this.newsList[0] || []
          this.pagination.current_page = table.curr
          this.pagination.per_page = table.size
          this.pagination.last_page = table.page
        }
      })
    },
    /**
     * top6新闻列表
     */
    topReadNews () {
      ApiWebArticleTopRead().then(({data}) => {
        if (data && data.status === 0) {
          this.topNewsList = data.data
          this.$nextTick(() => {
            var swiper = new Swiper('.swiper-container', { // eslint-disable-line no-unused-vars
              // pagination: '.swiper-pagination',
              nextButton: '.swiper-button-next',
              prevButton: '.swiper-button-prev',
              slidesPerView: 5,
              centeredSlides: true,
              loopFillGroupWithBlank: true,
              spaceBetween: 15,
              loop: true
            })
          })
        }
      })
    },
    /**
     * 初始化标签
     */
    initLabel () {
      ApiWebArticleHotLabel().then(({data}) => {
        if (data && data.status === 0) {
          this.labelList = data.data
        }
      })
    },
    /**
     * 新闻详情
     * @param id 新闻id
     */
    toNewsInfo (id) {
      this.$store.commit('news/setNewsId', id)
      this.$router.push({ name: 'newsDetail', params: { newsId: id } })
    },
    newsItemHover (item) {
      this.hoverNewsItem = item
    },
    /**
     * 跳转到标签详情页
     * label
     */
    gotoTipsPage (label) {
      this.$router.push({ name: 'newsTips', params: {label: label} })
    },
    /**
     * 新闻动态顶部背景图
     */
    topbackground () {
      ApiWebArticleBg().then(({data}) => {
        if (data && data.status === 0) {
          this.topBg = data.data
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  @import '../assets/style/index.less';
</style>



// WEBPACK FOOTER //
// src/components/news.vue